import classNames from 'classnames'
import {Icon} from 'quickstart/components/content'
import {dataProps} from 'quickstart/theme'
import {ComponentProps} from 'react'
import S from './styles.module.scss'

interface TagProps extends ComponentProps<'div'> {
  color?: 'neutral' | 'accent'
  inline?: boolean
  variant?: 'default' | 'pill'
}

const _Tag = ({
  children,
  color = 'neutral',
  inline = false,
  variant = 'default',
  ...props
}: TagProps) => (
  <div
    role="listitem"
    {...dataProps({color, inline, variant, clickable: !!props.onClick})}
    {...props}
    className={classNames(S.tag, props.className)}
  >
    <div className={S['tag-content']}>{children}</div>
    {!!props.onClick && (
      <div className={S['action-icon-wrapper']}>
        <Icon icon="close" size="100%" title="Remove" />
      </div>
    )}
  </div>
)

interface TagGroupProps extends ComponentProps<'div'> {
  title?: string
}

const TagGroup = ({children, title, ...props}: TagGroupProps) => (
  <div {...props} className={classNames(S['tag-group'], props.className)}>
    {title && <>{title} </>}
    {children}
  </div>
)

export const Tag = Object.assign(_Tag, {Group: TagGroup})
